import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import applicationsReducer from './applicationsReducer';
import authReducer from './authReducer';
import clientsReducer from './clientsReducer';
import usersReducer from './usersReducer';
import profileReducer from './profileReducer';
import businessLinesReducer from './businessLinesReducer';
import connectionsReducer from './connectionsReducer';

const rootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    applications: applicationsReducer,
    auth: authReducer,
    clients: clientsReducer,
    users: usersReducer,
    profile: profileReducer,
    businessLines: businessLinesReducer,
    connections: connectionsReducer,
  });

export default rootReducer;
